/** 监控 */
import intl from 'react-intl-universal';
// import { fetchIdCardList } from '@/api/computer';
import { reportIDCardReaderStatus } from '@/api/monitor';

// 身份证读卡器使用场景
export enum IDCardReaderScene {
  NewCheckIn, // 新入住抽屉,
  ExtendCheckIn, // 追加入住,
  ReserveToNewCheckIn, // 预订转新入住,
  ReserveToExtendCheckIn, // 预订转追加入住,
  OrderDetailAddGuest, // 订单详情页新增宾客,
  MemberCardPurchase, // 会员卡购买抽屉
  IDCardReaderTest, // 身份证读卡器测试
  StaffProfileEdit, // 员工资料编辑抽屉
}

const IDCardReaderSceneMap = {
  [IDCardReaderScene.NewCheckIn]: intl.get('utils_monitor_new_check_in'),
  [IDCardReaderScene.ExtendCheckIn]: intl.get('utils_monitor_extend_check_in'),
  [IDCardReaderScene.ReserveToNewCheckIn]: intl.get('utils_monitor_reserve_new_check_in'),
  [IDCardReaderScene.ReserveToExtendCheckIn]: intl.get('utils_monitor_reserve_Extend_check_in'),
  [IDCardReaderScene.OrderDetailAddGuest]: intl.get('utils_monitor_order_detail_add_guest'),
  [IDCardReaderScene.MemberCardPurchase]: intl.get('utils_monitor_member_card_purchase'),
  [IDCardReaderScene.IDCardReaderTest]: intl.get('utils_monitor_id_card_reader_test'),
  [IDCardReaderScene.StaffProfileEdit]: intl.get('utils_monitor_staff_profile_edit'),
};
export const trackIDCardReader = async (sceneConfig: { type: IDCardReaderScene }) => {
  const { type } = sceneConfig;
  // const extraData = {
  //   drive: undefined,
  // };
  // try {
  //   // 获取启用的身份证读卡器硬件
  //   const listRes = await fetchIdCardList({});
  //   const activeItem = listRes.data.find((item) => item.status === 1);
  //   extraData.drive = `${activeItem.brand} ${activeItem.equipmentModel}`;
  // } catch (e) {
  //   //
  // }
  reportIDCardReaderStatus({
    // ...extraData,
    source: IDCardReaderSceneMap[type],
  });
};

export const getClientVersion = () => {
  const version = window.navigator.userAgent.match(/PMS\/(\S*)/) || [];
  if (typeof window.electron !== 'undefined') {
    return version[1];
  }
  return 'web';
};

// 客户端信息上报
export const getClientReportInfo = () => {
  return {
    version: getClientVersion(),
  };
};
